export const INVITATION_STEPS = {
  INVITATION_SETUP: 1,
  TICKET_SETUP: 2,
  SUMMARY: 3,
} as const;

const TOTAL_STEPS = 3;

export const getStepInfo = (step: number) => {
  switch (step) {
    case INVITATION_STEPS.INVITATION_SETUP:
      return { current: INVITATION_STEPS.INVITATION_SETUP, total: TOTAL_STEPS, next: 'Настройка билета' };
    case INVITATION_STEPS.TICKET_SETUP:
      return { current: INVITATION_STEPS.TICKET_SETUP, total: TOTAL_STEPS, next: 'Отправка приглашения' };
    case INVITATION_STEPS.SUMMARY:
      return { current: INVITATION_STEPS.SUMMARY, total: TOTAL_STEPS, next: 'Финал' };
    default:
      return { current: INVITATION_STEPS.INVITATION_SETUP, total: TOTAL_STEPS, next: 'Настройка билета' };
  }
};

export const getHeaderTitle = (step: number) => {
  switch (step) {
    case INVITATION_STEPS.INVITATION_SETUP:
      return 'Настройка приглашения';
    case INVITATION_STEPS.TICKET_SETUP:
      return 'Настройка билета';
    case INVITATION_STEPS.SUMMARY:
      return 'Отправить приглашение';
    default:
      return 'Настройка приглашения';
  }
};
